import { GameData, Scenes } from ".";

const barScenes: Scenes = {
    // {{{
    barIntro: {
        id: "barIntro",
        video: "game/bar/barIntro.mp4",
        initialAction: {
            type: "switchScene",
            sceneId: "barQuestion",
        },
    },

    barQuestion: {
        id: "barQuestion",
        loop: "game/bar/barLoop.mp4",
        initialAction: {
            type: "if",
            if: {
                and: [
                    {
                        not: {
                            hasVisitedScene: "houseArrivalIntro",
                        },
                    },
                    {
                        hasVisitedScene: "barQuestionKey",
                    },
                    {
                        hasVisitedScene: "barQuestionLocation",
                    },
                ],
            },
            then: {
                type: "switchScene",
                sceneId: "houseArrivalIntro",
            },
        },
        elements: {
            barQuestion: {
                id: "barQuestion",
                type: "singleChoice",
                question: "Was willst du Dragica fragen?",
                answers: [
                    {
                        id: "barQuestion-a0",
                        text: "Haben sie den Schlüssel?",
                        action: {
                            type: "switchScene",
                            sceneId: "barQuestionKey",
                        },
                        disabled: {
                            and: [
                                {
                                    hasVisitedScene: "barQuestionKey",
                                },
                                {
                                    not: {
                                        hasVisitedScene: "houseArrivalIntro",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        id: "barQuestion-a1",
                        text: "Wo ist das Haus?",
                        action: {
                            type: "switchScene",
                            sceneId: "barQuestionLocation",
                        },
                        disabled: {
                            and: [
                                {
                                    hasVisitedScene: "barQuestionLocation",
                                },
                                {
                                    not: {
                                        hasVisitedScene: "houseArrivalIntro",
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    },

    barQuestionKey: {
        id: "barQuestionKey",
        video: "game/bar/barQuestionKey.mp4",
        loop: "game/bar/barLoop.mp4",
        initialAction: {
            type: "if",
            if: {
                hasVisitedScene: "houseArrivalIntro",
            },
            then: {
                type: "switchScene",
                sceneId: "houseArrivalIntro",
            },
            else: {
                type: "switchScene",
                sceneId: "barQuestion",
            },
        },
    },

    barQuestionLocation: {
        id: "barQuestionLocation",
        video: "game/bar/barQuestionLocation.mp4",
        loop: "game/bar/barLoop.mp4",
        initialAction: {
            type: "if",
            if: {
                hasVisitedScene: "houseArrivalIntro",
            },
            then: {
                type: "switchScene",
                sceneId: "houseArrivalIntro",
            },
            else: {
                type: "switchScene",
                sceneId: "barQuestion",
            },
        },
    },
}; // }}}

const houseArrivalScenes: Scenes = {
    houseArrivalIntro: {
        id: "houseArrivalIntro",
        video: "game/houseArrival/arrival.mp4",
        initialAction: {
            type: "switchScene",
            sceneId: "houseArrivalDoor",
        },
    },

    houseArrivalDoor: {
        id: "houseArrivalDoor",
        loop: "game/houseArrival/doorLoop.mp4",
        elements: {
            openDoor: {
                id: "openDoor",
                type: "clickArea",
                align: ["center", "center"],
                size: [400, 400],
                // size: [4, 4],
                // size: ["50%", "50%"],
                offset: [-320, 280],
                triggers: {
                    onClick: {
                        type: "onClick",
                        action: {
                            type: "switchScene",
                            sceneId: "houseArrivalDoorOpen",
                        },
                    },
                },
            },
        },
    },

    houseArrivalDoorOpen: {
        id: "houseArrivalDoorOpen",
        video: "game/houseArrival/doorOpen.mp4",
        initialAction: {
            type: "switchScene",
            sceneId: "houseBedCockroaches",
        },
    },
};

export const realData: GameData = {
    initialSceneId: "barIntro",
    scenes: {
        ...barScenes,
        ...houseArrivalScenes,
        houseBedCockroaches: {
            id: "houseBedCockroaches",
            video: {
                src: "game/house/bedCockroaches.mp4",
                style: {
                    objectFit: "contain",
                },
            },
        },
    },
};
